/**
* DevExtreme (bundles/dx.all.js)
* Version: 19.2.6
* Build date: Thu Jan 30 2020
*
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
*/
// This file is required to compile devextreme-angular


//////////////////
// WEBPACK FOOTER
// ./~/devextreme/bundles/dx.all.js
// module id = 72
// module chunks = 0